/**
 * Each "cell" is one card in the organic grid. We render at most one product
 * per cell — the highest-rated organic item the customer can receive — so the
 * combined grid stays in a roughly 10-16 card range across the catalog.
 *
 * `categoryId` and `queryKey` mirror the top filter chips on the Edit Delivery
 * Groceries page (`app/pages/spa/route-pages/GroceriesRoute.tsx`).
 */
export interface OrganicCell {
  key: string;
  badgeLabel: string;
  categoryId: number;
  queryKey: string;
}

export const ORGANIC_CELLS: readonly OrganicCell[] = [
  {
    key: 'produce',
    badgeLabel: 'Produce',
    categoryId: 1,
    queryKey: 'is_produce',
  },
  {
    key: 'snacks',
    badgeLabel: 'Snacks',
    categoryId: 11,
    queryKey: 'is_snacks',
  },
  {
    key: 'sweets',
    badgeLabel: 'Sweets',
    categoryId: 12,
    queryKey: 'is_sweets',
  },
  {
    key: 'drinks',
    badgeLabel: 'Drinks',
    categoryId: 10,
    queryKey: 'is_beverages',
  },
  {
    key: 'dairy-eggs',
    badgeLabel: 'Dairy + Eggs',
    categoryId: 9,
    queryKey: 'is_dairy_eggs',
  },
  {
    key: 'bread-bakery',
    badgeLabel: 'Bread + Bakery',
    categoryId: 3,
    queryKey: 'is_bread_bakery',
  },
  {
    key: 'cereal-oats',
    badgeLabel: 'Cereal + Oats',
    categoryId: 15,
    queryKey: 'is_cereal_oats',
  },
  {
    key: 'meat-seafood',
    badgeLabel: 'Meat + Seafood',
    categoryId: 5,
    queryKey: 'is_meat_seafood',
  },
  {
    key: 'plant-proteins',
    badgeLabel: 'Plant-Based',
    categoryId: 6,
    queryKey: 'is_plant_proteins',
  },
  {
    key: 'sauces-condiments',
    badgeLabel: 'Sauces',
    categoryId: 4,
    queryKey: 'is_sauces_condiments',
  },
  {
    key: 'grains-pastas',
    badgeLabel: 'Grains + Pastas',
    categoryId: 2,
    queryKey: 'is_grains_pastas',
  },
  {
    key: 'pantry',
    badgeLabel: 'Pantry',
    categoryId: 7,
    queryKey: 'is_pantry',
  },
];

/**
 * The Organic certifications filter on the Groceries page is serialized as
 * `certification_tags=15,814` (organic + organic-produce). Mirror that exact
 * value here so deep links pre-select the existing filter chip on mount.
 *
 * Source: `packages/app-public/src/components/Filters/ProductFiltersV2.tsx`
 * — "Certifications → Organic" entry.
 */
export const ORGANIC_CERTIFICATION_QUERY = {
  key: 'certification_tags',
  value: '15,814',
} as const;
